export const API_URL = process.env.VUE_APP_API_URL;
export const API_ERROR_MESSAGE = "Ошибка выполнения";

// IKP
export const SHOULD_SHOW_MED_PARAMS_EXCESS_MEASUREMENT_CHART = process.env.VUE_APP_SHOULD_SHOW_MED_PARAMS_EXCESS_MEASUREMENT_CHART
  ? process.env.VUE_APP_SHOULD_SHOW_MED_PARAMS_EXCESS_MEASUREMENT_CHART === "true"
  : true;
export const SHOULD_SHOW_MED_PARAMS_AVERAGE_MEASUREMENT_CHART = process.env
  .VUE_APP_SHOULD_SHOW_MED_PARAMS_AVERAGE_MEASUREMENT_CHART
  ? process.env.VUE_APP_SHOULD_SHOW_MED_PARAMS_AVERAGE_MEASUREMENT_CHART === "true"
  : true;

export const VUE_APP_SHOW_ALL_METRICS_IKP = process.env.VUE_APP_SHOW_ALL_METRICS_IKP
  ? process.env.VUE_APP_SHOW_ALL_METRICS_IKP === "true"
  : true;

export const VUE_APP_COVIDER_LINK = process.env.VUE_APP_COVIDER_LINK || "https://covider.domain.ru";

export const VUE_APP_BRANDING_LOGO = process.env.VUE_APP_BRANDING_LOGO || "branding/logo-default.svg";
export const VUE_APP_BRANDING_TITLE = process.env.VUE_APP_BRANDING_TITLE || "Кабинет";
export const VUE_APP_BRANDING_PRINT_HEADER = process.env.VUE_APP_BRANDING_PRINT_HEADER || "";
export const VUE_APP_BRANDING_PRINT_FOOTER = process.env.VUE_APP_BRANDING_PRINT_FOOTER || "";
export const VUE_APP_FAKE_DOCUMENT_AUTHOR = process.env.VUE_APP_FAKE_DOCUMENT_AUTHOR || false;

export const VUE_APP_V3_HOST = process.env.VUE_APP_V3_HOST || "https://doctor-v3.healthkeeper.ru";

export default {
  API_URL,
  API_ERROR_MESSAGE,
  SHOULD_SHOW_MED_PARAMS_EXCESS_MEASUREMENT_CHART,
  SHOULD_SHOW_MED_PARAMS_AVERAGE_MEASUREMENT_CHART,
  VUE_APP_SHOW_ALL_METRICS_IKP,
  VUE_APP_COVIDER_LINK,
  VUE_APP_V3_HOST,
  VUE_APP_BRANDING_LOGO,
  VUE_APP_BRANDING_TITLE,
  VUE_APP_BRANDING_PRINT_HEADER,
  VUE_APP_BRANDING_PRINT_FOOTER,
  VUE_APP_FAKE_DOCUMENT_AUTHOR,
};
